module.exports = __webpack_public_path__ + "static/img/auth-bg.92dd130.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth-bg.jpg
// module id = 9lqd
// module chunks = 36